class HeroVideoDeferred extends HTMLElement {
  #loaded = false;

  connectedCallback() {
    this.video = this.querySelector('video');
    this.sources = [...this.querySelectorAll('source[data-video-source]')];

    if (!this.video || this.sources.length === 0) return;

    // Keep the existing poster on mobile: typing/searching is not video consent.
    // Desktop retains its existing presentation; reduced-motion uses the poster.
    if (window.matchMedia('(max-width: 749px)').matches ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.#loadVideo();
  }

  #loadVideo = () => {
    if (this.#loaded) return;
    this.#loaded = true;

    for (const source of this.sources) {
      const sourceUrl = source.dataset.videoSource;
      if (sourceUrl) source.src = sourceUrl;
    }

    this.video.load();
    this.video.play().catch(() => {});
  };
}

if (!customElements.get('hero-video-deferred')) {
  customElements.define('hero-video-deferred', HeroVideoDeferred);
}
